import { FadeInSection } from '../../../components/ui'
import { STEPS } from '../../../data'

// Per-step flat background colors — Mailchimp section rhythm
const STEP_COLORS = ['#FBE6D4', '#FFE8C2', '#E7F0E3', '#F4E1F0']

const STEP_ICONS: Record<string, React.ReactNode> = {
  '01': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
      <path d="M19 8v6M22 11h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  '02': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  '03': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  '04': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 8.5a3.5 3.5 0 0 1 6-2.45A3.5 3.5 0 0 1 16 8.5c0 4-6 8-6 8s-6-4-6-8z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M14 19h6M17 16l3 3-3 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}

export default function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="py-28 px-6"
      style={{ backgroundColor: '#FAF5EC', borderBottom: '2px solid #111' }}
    >
      <div className="max-w-6xl mx-auto">
        <FadeInSection>
          <div className="max-w-2xl mb-16">
            <span
              className="inline-block text-xs font-bold uppercase font-dm-mono"
              style={{
                backgroundColor: '#111',
                color: '#FAF5EC',
                padding: '5px 12px',
                borderRadius: 999,
                letterSpacing: '0.14em',
              }}
            >
              How it works
            </span>
            <h2
              className="font-extrabold mt-5 tracking-tight"
              style={{
                color: '#111',
                fontSize: 'clamp(2.25rem, 5vw, 3.75rem)',
                lineHeight: 1,
                letterSpacing: '-0.03em',
              }}
            >
              Four steps. Then it
              <br />
              runs itself.
            </h2>
            <p
              className="mt-5 text-lg"
              style={{ color: '#3a2e26', lineHeight: 1.55, maxWidth: 560 }}
            >
              Set it up once. Nudge runs in the background, every day, no maintenance needed.
            </p>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {STEPS.map((item, i) => (
            <FadeInSection key={item.step} delay={i * 0.06}>
              <div
                className="step-tile h-full p-8 transition-transform duration-150"
                style={{
                  backgroundColor: STEP_COLORS[i % STEP_COLORS.length],
                  border: '2px solid #111',
                  borderRadius: 20,
                  boxShadow: '6px 6px 0 #111',
                }}
              >
                <div className="flex items-center justify-between mb-6">
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      backgroundColor: '#111',
                      color: '#fff',
                    }}
                  >
                    {STEP_ICONS[item.step]}
                  </div>
                  <span
                    className="font-extrabold font-dm-mono"
                    style={{ color: '#111', fontSize: '2.25rem', lineHeight: 1, opacity: 0.18, letterSpacing: '-0.02em' }}
                  >
                    {item.step}
                  </span>
                </div>

                <h3
                  className="font-extrabold tracking-tight mb-3"
                  style={{
                    color: '#111',
                    fontSize: '1.5rem',
                    lineHeight: 1.15,
                    letterSpacing: '-0.02em',
                  }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-base"
                  style={{ color: '#3a2e26', lineHeight: 1.55 }}
                >
                  {item.desc}
                </p>
              </div>
            </FadeInSection>
          ))}
        </div>

        <style>{`
          .step-tile:hover {
            transform: translate(-2px, -2px);
            box-shadow: 8px 8px 0 #111 !important;
          }
        `}</style>
      </div>
    </section>
  )
}
